import { QueryClient } from '@tanstack/react-query';
import { isAxiosError } from './api';

// ─────────────────────────────────────────────────────────────────────────────
// React Query client
//
// staleTime tiers:
//   Public data   — 2 minutes  (posts, categories, tags)
//   Admin data    — 30 seconds (used in individual hooks via options override)
//
// Retry policy:
//   - Never retry 401 (auth error — interceptor handles token refresh)
//   - Never retry other 4xx (client errors won't resolve on retry)
//   - Retry up to 1× for 5xx / network errors
// ─────────────────────────────────────────────────────────────────────────────

export const PUBLIC_STALE_MS = 2 * 60 * 1_000;   // 2 min
export const ADMIN_STALE_MS  = 30 * 1_000;        // 30 s

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: PUBLIC_STALE_MS,
      refetchOnWindowFocus: false,
      retry(failureCount, error) {
        if (isAxiosError(error)) {
          const status = error.response?.status;
          // Never retry auth errors (interceptor already attempted refresh)
          if (status === 401) return false;
          // Never retry other 4xx — bad request, forbidden, not found
          if (status !== undefined && status >= 400 && status < 500) return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: 0,
    },
  },
});
